import React from "react";
import useEducation from "./useEducation";
import Education from "./Components/Education";

const EducationIndex: React.FC = () => {

  return <Education />;
};
export default EducationIndex;
